import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';

@Component({
  selector: 'user-details-modal',
  templateUrl: './user-details-modal.component.html',
})
export class UserDetailsModalComponent implements OnInit {

  @Input() userDetails: any;

  public user: any = [];
  public routeRole: any;

  constructor(
    private activeModal: NgbActiveModal,
    private router: Router,
    globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.mapUserDetails(this.userDetails);
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public mapUserDetails(user) {
    this.user = {
      name: `${user.firstName} ${user.lastName}`,
      company: user.workerUser && user.workerUser.maintenance ? user.workerUser.maintenance.name : '',
      phone: user.phoneNumber,
      email: user.email,
      id: user.id
    };
  }

  public goToWorker(skylarkUserId) {
    this.router.navigate(['/' + this.routeRole + '/workers/' + skylarkUserId], {
      queryParams: { backLink: this.router.url }
    });
    this.closeModal();
  }

}
